import Model from 'flarum/common/Model';
import computed from 'flarum/common/utils/computed';
export default class UsernameRequest extends Model {
  user() {
    return Model.hasOne('user').call(this);
  }
  status() {
    return Model.attribute('status').call(this);
  }
  reason() {
    return Model.attribute('reason').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  forNickname() {
    return Model.attribute('forNickname').call(this);
  }
  _requestedUsername() {
    return Model.attribute('requestedUsername').call(this);
  }
  requestedUsername() {
    return computed('_requestedUsername', 'forNickname', 'user', function (newName, forNickname, user) {
      return newName === null && forNickname ? user.username() : newName;
    }).call(this);
  }
}
flarum.reg.add('fof-username-request', 'forum/models/UsernameRequest', UsernameRequest);